export enum ChildrenFormSettingsVariant {
  HasAny = 'has_any',
  No = 'no',
  Settings = 'settings'
}
